"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_USER_UNDERLINGS = void 0;
var client_1 = require("@apollo/client");
exports.GET_USER_UNDERLINGS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetUserUnderlings($input: UserUnderlingsInput) {\n    userUnderlings(input: $input) {\n      id\n      uuid\n      firstName\n      lastName\n      email\n    }\n  }\n"], ["\n  query GetUserUnderlings($input: UserUnderlingsInput) {\n    userUnderlings(input: $input) {\n      id\n      uuid\n      firstName\n      lastName\n      email\n    }\n  }\n"])));
var templateObject_1;
